@switch (imageVariant()) {
	@case ('single') {
		@if (images()?.length) {
			<div class="relative h-full w-28 min-w-full md:w-44 lg:w-64">
				<vp-image
					[className]="
						cn(imageClass(), 'aspect-square md:aspect-video')
					"
					[image]="{
						src: images()![0].src,
						altText: images()![0].alt,
						width: 652,
						height: 460,
					}"
					className="size-full"
				/>
				@if (imageRibbon()) {
					<div
						class="absolute -left-4 top-4 whitespace-nowrap sm:-left-5 sm:top-5"
					>
						<vp-ribbon
							[maxLength]="15"
							[text]="imageRibbon()"
							color="yellow"
						/>
					</div>
				}
			</div>
		}
	}
	@case ('modal-carousel') {
		@if (images()?.length) {
			<vp-carousel-modal
				[images]="images()"
				class="relative"
				className="h-full"
			>
				<div class="relative h-full w-28 min-w-full md:w-44 lg:w-64">
					<vp-image
						[className]="imageClass()"
						[image]="{
							src: images()![0].src,
							altText: images()![0].alt,
							width: 652,
							height: 460,
						}"
						className="size-full"
					/>
					<div
						class="absolute bottom-0 right-0 rounded-br-sm rounded-tl-2xl bg-[#000]/50 pb-2 pl-3 pr-2 pt-3"
					>
						<svg-icon
							class="block size-4 text-white"
							src="assets/icons/icon-looking-glass.svg"
							svgAriaLabel="Open"
						/>
					</div>
				</div>

				@if (imageRibbon()) {
					<div
						class="absolute -left-4 top-4 whitespace-nowrap sm:-left-5 sm:top-5"
					>
						<vp-ribbon
							[maxLength]="15"
							[text]="imageRibbon()"
							color="yellow"
						/>
					</div>
				}
			</vp-carousel-modal>
		}
	}

	@case ('mini-carousel') {
		<vp-mini-carousel
			[aspectRatio]="aspectRatio()"
			[className]="
				useVerticalCard()
					? 'card-image-border-radius-t'
					: 'card-image-border-radius-t md:card-image-border-radius-l'
			"
			[dynamicHeight]="dynamicHeight()"
			[items]="carouselItems()"
			class="h-auto min-w-full"
		/>
	}

	@case ('grid') {
		<vp-image-grid
			[className]="
				useVerticalCard()
					? 'card-image-border-radius-t'
					: 'card-image-border-radius-t md:card-image-border-radius-l'
			"
			[images]="images() || []"
			[size]="gridSize()"
		/>
	}
}
